import { render, staticRenderFns } from "./QueueBuster.vue?vue&type=template&id=345b2244&scoped=true"
import script from "./QueueBuster.vue?vue&type=script&lang=ts"
export * from "./QueueBuster.vue?vue&type=script&lang=ts"
import style0 from "./QueueBuster.vue?vue&type=style&index=0&id=345b2244&prod&lang=scss&scoped=true"
import style1 from "./QueueBuster.vue?vue&type=style&index=1&id=345b2244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b2244",
  null
  
)

export default component.exports